'use client'

import type { ValidationError } from 'yup'
import { getInputElementFromForm } from '../hooks/helpers/validateFieldsAndSetValidity'

/**
 * @description
 * Sets the custom validation property for inputs with custom validation based on if they are
 * present in the given validation messages. Also triggers a blur event on the input so that
 * user-invalid gets set and validation message is shown in ValidationMessages component.
 *
 * @param fields -- the fields in the form with custom validation
 * @param formElement -- the form the fields are linked to
 * @param validationMessages -- validation messages.
 */
export const setCustomValidityForFieldsAndTriggerBlur = (
    fields: string[],
    formElement: HTMLFormElement | null,
    validationMessages: Pick<ValidationError, 'path' | 'message'>[]
) => {
    if (!formElement) return

    fields?.forEach((field) => {
        const input = getInputElementFromForm(field, formElement)
        if (!input) return
        if (validationMessages.some(({ path }) => path?.toLowerCase() === field?.toLowerCase())) {
            input.setCustomValidity('not valid')
            input.focus()
            input.blur()
        } else {
            input.setCustomValidity('')
        }
    })
}
